// web/src/utils/resultUrl.js

const BAN_URL_PREFIX = "b1_";

function base64UrlEncode(str) {
  const bytes = new TextEncoder().encode(String(str));
  let binary = "";

  for (const b of bytes) {
    binary += String.fromCharCode(b);
  }

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

function base64UrlDecode(str) {
  const s = String(str || "");
  const base64 = s
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(Math.ceil(s.length / 4) * 4, "=");

  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  return new TextDecoder().decode(bytes);
}

export function encodeBanIdForUrl(banId) {
  if (!banId) return "";
  return `${BAN_URL_PREFIX}${base64UrlEncode(String(banId))}`;
}

export function decodeBanIdFromUrl(value) {
  const raw = decodeURIComponent(String(value || ""));

  // Compatibilité avec les anciennes URLs :
  // /results/<vrai_ban_id>
  if (!raw.startsWith(BAN_URL_PREFIX)) {
    return raw;
  }

  try {
    return base64UrlDecode(raw.slice(BAN_URL_PREFIX.length));
  } catch (e) {
    console.error("[resultUrl] decodeBanIdFromUrl failed:", e);
    return raw;
  }
}

export function resultPathFromBanId(banId) {
  return `/results/${encodeURIComponent(encodeBanIdForUrl(banId))}`;
}